import 'bootstrap';
import jquery from 'jquery';
import Popper from 'popper.js';
import { TweenMax } from 'gsap';
import moment from 'moment';
import _ from 'lodash';
import Swal from 'sweetalert2';
import io from 'socket.io-client';
window.debounce = _.debounce;

moment.locale('de');

window.$ = window.jQuery = jquery;
window.Popper = Popper;
window.TweenMax = TweenMax;
window.moment = moment;
window._ = window.lodash = _;
window.Swal = Swal;
window.io = io;

import './prototypes';
import './Vue';
import './axios';
import './worker';
import './URLBuilder';

function fetchPost(url, data) {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    let object = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': token.content,
        },
    };
    if(data) {
        object.body = JSON.stringify(data);
    }
    return fetch(url, object);
}
window.fetchPost = fetchPost;
